import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const createPaymentContextMutation = gql`
  mutation CreatePaymentContext($input: CreatePaymentContextInput!) {
    createPaymentContext(input: $input) {
      uuid
      orderId
    }
  }
`

export const createPaymentContextKey = getQueryNames(createPaymentContextMutation)[0]

export default createPaymentContextMutation
